// ============================================================================
// DOCUMENT FACTORY HUB REPOSITORY
// ARQUIVO: src/services/DocumentFactoryHubRepository.js
// RESPONSABILIDADE: Operações Firestore do DocumentFactoryHub.
// Criado: Fase 6.3 — mover Firestore direto de DocumentFactoryHub.jsx para repositório.
// ============================================================================

import {
  collection, doc, getDoc, getDocs, onSnapshot, query, orderBy, updateDoc, addDoc, deleteDoc, limit, serverTimestamp
} from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

/** Busca clientId de um processo (autos_workspaces).
 * Fusão Processos/Caderno (MC31): processes vazia - redireciona. */
export async function fetchProcessClientId(processId, appId) {
  const safeProcessId = String(processId || '').trim();
  if (!safeProcessId || !appId) return '';
  try {
    const procRef = doc(db, 'artifacts', appId, 'public', 'data', 'autos_workspaces', safeProcessId);
    const procSnap = await getDoc(procRef);
    const proc = procSnap && typeof procSnap.exists === 'function' && procSnap.exists() ? procSnap.data() || {} : {};
    return String(proc?.clientId || '').trim();
  } catch {
    return '';
  }
}

/** Carrega clientes e processos (autos_workspaces) para cache de busca. */
export async function loadClientsAndProcesses(appId) {
  let clientsRows = [];
  let procRows = [];
  try {
    const clientsRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients');
    const snapClients = await getDocs(query(clientsRef, limit(250)));
    clientsRows = snapClients.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
  } catch { clientsRows = []; }
  try {
    const processesRef = collection(db, 'artifacts', appId, 'public', 'data', 'autos_workspaces');
    const snapProc = await getDocs(query(processesRef, limit(250)));
    procRows = snapProc.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
  } catch { procRows = []; }
  return { clientsRows, procRows };
}

/** Atualiza documento existente. */
export async function updateDocument(docId, payload, appId) {
  const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'documents', docId);
  await updateDoc(docRef, { ...payload, updatedAt: serverTimestamp() });
}

/** Adiciona nota ao cliente. */
export async function addClientNote(targetClientId, noteData, appId) {
  const notesRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients', targetClientId, 'notes');
  await addDoc(notesRef, { ...noteData, createdAt: serverTimestamp() });
}

/** Observa documentos (onSnapshot). */
export function watchDocuments(appId, onData) {
  const docsRef = collection(db, 'artifacts', appId, 'public', 'data', 'documents');
  const q = query(docsRef, orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => {
    onData(snap.docs.map((d) => {
      const data = d.data();
      const safeCategory = data.classification?.category || data.category || 'LEGADO';
      return {
        ...data,
        id: d.id,
        category: safeCategory,
      };
    }));
  });
}

/** Deleta documento. */
export async function deleteDocument(docId, appId) {
  await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'documents', docId));
}
